import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, LayoutGrid, ShoppingCart, User } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { useAuth } from '../context/AuthContext';

// Persistent bottom tab bar shown only on small screens (md:hidden) so mobile
// feels like a dedicated shopping app rather than a shrunk desktop layout.
// The top Navbar's hamburger menu still covers secondary links (Support,
// About, Wholesale, Contact) — this bar is only the 4 highest-frequency
// destinations a shopper returns to constantly.
const TABS = [
  { to: '/', label: 'Home', icon: Home, match: (pathname) => pathname === '/' },
  { to: '/categories', label: 'Categories', icon: LayoutGrid, match: (pathname) => pathname.startsWith('/categories') },
  { to: '/cart', label: 'Cart', icon: ShoppingCart, match: (pathname) => pathname === '/cart' },
];

const MobileBottomNav = () => {
  const { pathname } = useLocation();
  const { itemCount } = useCart();
  const { authStatus } = useAuth();

  const accountTab = {
    to: authStatus === 'authenticated' ? '/account' : '/login',
    label: 'Account',
    icon: User,
    match: (p) => p === '/account' || p === '/login',
  };

  return (
    <nav
      aria-label="Primary"
      className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-white/95 backdrop-blur-xl border-t border-emerald-100 shadow-glass pb-[env(safe-area-inset-bottom)]"
    >
      <div className="grid grid-cols-4">
        {[...TABS, accountTab].map((tab) => {
          const Icon = tab.icon;
          const active = tab.match(pathname);
          return (
            <Link
              key={tab.label}
              to={tab.to}
              aria-current={active ? 'page' : undefined}
              className="relative flex flex-col items-center justify-center gap-0.5 py-2.5 focus-visible:outline-none focus-visible:bg-emerald-50"
            >
              <span className="relative">
                <Icon
                  size={22}
                  className={active ? 'text-emerald-700' : 'text-gray-400'}
                  strokeWidth={active ? 2.4 : 2}
                  aria-hidden="true"
                />
                {tab.label === 'Cart' && itemCount > 0 && (
                  <span className="absolute -top-1.5 -right-2 min-w-[1.05rem] h-[1.05rem] px-1 rounded-full bg-accent-500 text-white text-[9px] font-bold flex items-center justify-center shadow-soft">
                    {itemCount > 99 ? '99+' : itemCount}
                  </span>
                )}
              </span>
              <span className={`text-[10px] font-medium ${active ? 'text-emerald-700' : 'text-gray-400'}`}>
                {tab.label}
              </span>
              {active && (
                <span className="absolute top-0 inset-x-1/4 h-0.5 rounded-full bg-gradient-primary" aria-hidden="true" />
              )}
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileBottomNav;
